import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { capitalize } from '@material-ui/core';
import RadioOption from './RadioOption';

const styles = () => ({
  root: {},
  label: {},
});


const MUI_COLORS = [
  'primary',
  'secondary',
  'default',
];

export const COLORS = [
  ...MUI_COLORS,
  'white',
];

const getColorProp = (color) => {
  if (COLORS.includes(color)) {
    return color;
  }
  return 'default';
};

const getRootColor = (color) => {
  return {
    color,
  };
};

const getRadioOptionColor = (color) => {
  return {
    color,
  };
};

const useCustomStyles = makeStyles(theme => ({
  rootColorPrimary: {},
  rootColorSecondary: {},
  rootColorWhite: getRootColor(theme.palette.common.white),
  radioOptionPrimary: {},
  radioOptionColorSecondary: {},
  radioOptionColorWhite: getRadioOptionColor(theme.palette.common.white),
}));

const Radio = ({
  className,
  classes,
  label,
  options,
  onChange,
  value,
  color,
  shouldDisableOption,
}) => {
  const {
    root: rootClass,
    ...restClasses
  } = classes;

  const customClasses = useCustomStyles();

  return (
    <FormControl
      className={classNames(classes.root, className)}
      component="fieldset"
    >
      {label && <FormLabel component="legend" className={classes.label}>{label}</FormLabel>}
      <RadioGroup
        value={value}
        className={className}
        classes={{
          ...restClasses,
          root: classNames(rootClass, className, customClasses[`rootColor${capitalize(color)}`]),
        }}
        onChange={(evt) => {
          return onChange(evt.target.value);
        }}
      >
        {options.map((option) => {
          return (
            <RadioOption
              className={classNames(customClasses[`radioOptionColor${capitalize(color)}`])}
              key={option.value}
              label={option.prompt}
              value={option.value}
              disabled={shouldDisableOption(option.value)}
              color={getColorProp(color)}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

Radio.defaultProps = {
  className: '',
  label: null,
  color: 'inherit',
  value: '',
  shouldDisableOption: () => false,
};

Radio.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  shouldDisableOption: PropTypes.func,
  value: PropTypes.string,
  color: PropTypes.oneOf(COLORS),
};

export default withStyles(styles)(Radio);
